import { Link } from 'react-router-dom';

/**
 * Một **dòng** tóm tắt dẫn sang trang khác: tiêu đề, vài cặp nhãn–số, link.
 *
 * Thay thẻ cao 160px của bản cũ. Kho nhạc và Sản xuất ở trang Tổng quan là
 * thông tin phụ: khi có số thì một dòng là đủ, còn khi **toàn số 0** thì trang
 * không hiện gì cả (xem `TrangTongQuan`) — ba thẻ in số 0 chỉ dạy người dùng
 * bỏ qua cả vùng đó.
 */

export interface DongTomTatProps {
  tieuDe: string;
  to: string;
  nhanLink: string;
  phan: { nhan: string; giaTri: string | number; canhBao?: boolean }[];
  /** Một câu làm rõ con số, ví dụ "2 đã đăng · 1 chờ kiểm duyệt". */
  ghiChu?: string;
}

export function DongTomTat({ tieuDe, to, nhanLink, phan, ghiChu }: DongTomTatProps) {
  return (
    <section className="flex flex-wrap items-center gap-x-6 gap-y-2 rounded-the border border-vien bg-be-mat px-5 py-3">
      <h2 className="text-tieu-de-khoi font-semibold text-chu">{tieuDe}</h2>

      <dl className="flex flex-wrap items-center gap-x-5 gap-y-1">
        {phan.map((p) => (
          <div key={p.nhan} className="flex items-baseline gap-1.5">
            <dt className="text-phu text-chu-phu">{p.nhan}</dt>
            <dd
              className={`so-lieu text-co-ban font-semibold ${p.canhBao === true ? 'text-warn-chu' : 'text-chu'}`}
            >
              {typeof p.giaTri === 'number' ? p.giaTri.toLocaleString('vi-VN') : p.giaTri}
            </dd>
          </div>
        ))}
      </dl>

      {ghiChu !== undefined && ghiChu !== '' && <p className="text-phu text-chu-phu">{ghiChu}</p>}

      <Link to={to} className="ms-auto text-phu font-semibold text-nhan hover:text-nhan-dam">
        {nhanLink} →
      </Link>
    </section>
  );
}
